// frontend/src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from "jwt-decode"; 
import api from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = () => {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('token'); 
    setUserInfo(null);
  };

  useEffect(() => {
    const storedUserInfo = localStorage.getItem('userInfo');
    const storedToken = localStorage.getItem('token');

    if (storedUserInfo && storedToken) {
      try {
        const decoded = jwtDecode(storedToken);
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          console.warn("Token süresi dolmuş. Çıkış yapılıyor...");
          logout();
        } else {
          setUserInfo(JSON.parse(storedUserInfo));
        }
      } catch (error) {
        console.error("Token hatası:", error);
        logout();
      }
    } else {
        // Eksik bilgi varsa temizle
        logout();
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // api.js içindeki ayarlı axios'u kullanıyoruz
    const { data } = await api.post('/auth/login', { email, password });
    
    localStorage.setItem('userInfo', JSON.stringify(data));
    localStorage.setItem('token', data.token); 
    
    setUserInfo(data);
  };

  const value = {
    userInfo,
    isAuthenticated: !!userInfo, 
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};